/**
 * Corporations API — backend calls for the cross-corporation Corporations page.
 *
 * Read:   getcorps                (all corporations + their campus names)
 *         att_user_roles fetchall (impersonate role dropdown)
 * Write:  corp_add                (add new / migrate corporation)
 */

import { apiFetch, apiTransaction } from '../../../../services/api.js';

// ---------------------------------------------------------------------------
// READ operations
// ---------------------------------------------------------------------------

/**
 * Fetch all corporations across all campuses.
 *
 * V1 procedure: getcorps
 * The empty filters return all corporations.
 */
export function fetchCorporations(campusId, readOnly = true) {
  return apiFetch({
    procedure: 'getcorps',
    reqType: 'stored',
    pKey: 'campus_id',
    pVal: campusId,
    payload: { corp_filter: '', campus_filter: '' },
    readOnly,
  });
}

/**
 * Fetch all user roles (for the Impersonate role dropdown).
 *
 * V1: Tbl: "att_user_roles", procedure: "fetchall", reqType: "direct"
 */
export function fetchUserRoles(campusId) {
  return apiFetch({
    procedure: 'fetchall',
    reqType: 'direct',
    table: 'att_user_roles',
    pKey: 'campus_id',
    pVal: campusId,
    readOnly: true,
  });
}

// ---------------------------------------------------------------------------
// WRITE operations
// ---------------------------------------------------------------------------

/**
 * Add a new corporation or migrate a corporation from 2.0.
 *
 * V1 TransType: corp_add
 *
 * @param {object} corpData — { corporate_name, corporate_guid, address, state, city, country, zipcode, migrate }
 * @param {object} session — { campusId, userId, clientId }
 * @returns {Promise<[boolean, string?]>}
 */
export function addCorporation(corpData, session) {
  return apiTransaction({
    transType: 'corp_add',
    payload: [corpData],
    campusId: session.campusId,
    userId: session.userId,
    clientId: session.clientId,
  });
}
